<template>
    <div v-loading="loading">
        <el-form
            :inline="true"
            :model="dataForm"
            @submit.native.prevent>
            <el-form-item label="业务类型：" props="busType">
                <el-select v-model="dataForm.busType" clearable value-key="value" style="width:100%;"
                           @change="seachBtn">
                    <el-option v-for="(item,index) in businessTypeNamelist" :key="index" :label="item.name"
                               :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-if="showFormType" label="表单类型：" props="formType">
                <el-select v-model.number="dataForm.formType" clearable value-key="value" style="width:100%;"
                           @change="seachBtn">
                    <el-option v-for="item in formTypeList" :key="item.id" :label="item.text"
                               :value="item.id"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-input
                    v-model="dataForm.searchKey"
                    placeholder="请输入关键字"
                    @keyup.enter.native="getDataList()"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" @click="seachBtn">查询</el-button>
            </el-form-item>
        </el-form>
        <div style="position: relative;top:-10px">
            <el-button size="small" icon="el-icon-plus" type="primary"
                       @click="addOrUpdateHandle('')">新增
            </el-button>
            <el-button size="small" icon="el-icon-delete" type="primary"
                       @click="deleteHandle()">删除
            </el-button>
            <el-button size="small"
                       icon="el-icon-download"
                       type="primary"
                       @click="exportTableData()">导出
            </el-button>
            <el-upload
                class="upload-demo"
                style="display: inline-block;width: 100px;margin-left: 10px"
                :action="actionUrl"
                :data="actionQuery"
                :before-upload="beforeFileUpload"
                :on-change="fileChange"
                :on-success="handleUploadSuccess"
                :on-error="handleUploadError"
                :show-file-list="false"
                :list-type="'xlsx'"
                accept=".xlsx">
                <el-button size="small" icon="el-icon-upload" type="primary">导入
                </el-button>
            </el-upload>
        </div>
        <el-table
            :data="dataList"
            border
            ref="customFormList"
            :height="tableMaxHeight"
            v-loading="dataListLoading"
            @selection-change="selectionChangeHandle"
            style="width: 100%">
            <el-table-column
                fixed
                type="index"
                align="center"
                label="序号"
                width="60"
                :index="getRowsIndex"
            >
            </el-table-column>
            <el-table-column fixed type="selection" align="center"
                             :show-overflow-tooltip='true'></el-table-column>
            <el-table-column
                fixed
                header-align="center"
                align="center"
                width="150"
                label="操作"
            >
                <template slot-scope="scope">
                    <el-button
                        type="text"
                        size="small"
                        @click="configDataset(scope.row)">
                        配置
                    </el-button>
                    <el-button
                        type="text"
                        size="small"
                        @click="addOrUpdateHandle(scope.row.id)">
                        修改
                    </el-button>
                    <!--                    <el-button-->
                    <!--                            type="text"-->
                    <!--                            size="small"-->
                    <!--                            @click="showTest(scope.row)">-->
                    <!--                        测试模版-->
                    <!--                    </el-button>-->
                    <el-button
                        type="text"
                        size="small"
                        @click="deleteHandle(scope.row.id)">
                        删除
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column
                prop="code"
                header-align="left"
                width="150"
                align="left"
                label="表单编号"
            >
            </el-table-column>
            <el-table-column
                prop="title"
                header-align="left"
                align="left"
                label="表单名称"
            >
            </el-table-column>
            <el-table-column
                prop="formType"
                header-align="center"
                align="center"
                width="80"
                label="表单类型"
            >
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.formType == 0" size="small">列表</el-tag>
                    <el-tag v-else-if="scope.row.formType == 2" type="success" size="small">编辑</el-tag>
                    <el-tag v-else size="small" type="danger">明细</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                prop="hasAttach"
                header-align="center"
                align="center"
                width="110"
                label="是否支持附件"
            >
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.hasAttach == true" size="small">是</el-tag>
                    <el-tag v-else size="small" type="danger">否</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                prop="hasFlow"
                header-align="center"
                align="center"
                width="110"
                label="是否支持流程"
            >
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.hasFlow == true" size="small">是</el-tag>
                    <el-tag v-else size="small" type="danger">否</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                prop="createTime"
                header-align="center"
                align="center"
                width="180"
                label="创建时间"
            >
            </el-table-column>

        </el-table>
        <el-pagination
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
            :current-page="pageIndex"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            :total="totalPage"
            layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update
            v-if="addOrUpdateVisible"
            ref="addOrUpdate"
            @refreshDataList="getDataList"
        ></add-or-update>
        <list-config-dialog ref="listConfigDialogRef"
                            :form-id="selectRow.id"
                            :title="selectRow.title"
        ></list-config-dialog>
        <detail-config-dialog ref="detailConfigDialogRef"
                              :form-id="selectRow.id"
                              :bus-type="selectRow.busType"
                              :show-history-tag="selectRow.showHistoryTag"
        ></detail-config-dialog>
    </div>
</template>

<script>
import AddOrUpdate from "./Edit";
import ListConfigDialog from "./ListConfigDialog";
import DetailConfigDialog from "./DetailConfigDialog";
import {
    apiCustomformDelete,
    apiCustomformExport,
    apiCustomformList,
    apiSysDictDataGetList
} from "../../server/formConfig";
import {resetApiInstanceUrl} from "../../server/request";
// import {removeTabHandle} from '@/utils/routeTab';

export default {
    name: 'pm-form-config',
    components: {
        AddOrUpdate,
        ListConfigDialog,
        DetailConfigDialog,
    },
    props: ["mainContentViewHeight"],
    data() {
        return {
            loading: false,
            actionUrl: '/customform/import',
            actionQuery: {},
            dataForm: {
                busType: '',
                formType: this.$customFormGlobalConfig.defalueFormTypeId ? this.$customFormGlobalConfig.defalueFormTypeId : '',
                searchKey: "",
            },
            tableMaxHeight: document.documentElement.clientHeight - 285,
            businessTypeNamelist: [],
            dataList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false,
            formTypeList: [{id: 0, text: '列表'}, {id: 1, text: '明细'}],
            selectRow: {},
            showFormType: !this.$customFormGlobalConfig.hiddenFormType,
        };
    },
    created() {
        this.getDic('jz_dgwitness_bustype');
        this.actionUrl = resetApiInstanceUrl(this.actionUrl)
        this.getDataList();
    },
    mounted() {
        const that = this;
        let resizeTag = true;
        window.onresize = () => {
            if (resizeTag) { //防抖动
                that.ifmove();
                resizeTag = false
                setTimeout(() => {
                    resizeTag = true
                }, 1000)
            }
        }
        that.ifmove();
    },
    methods: {
        handleUploadError(err, file, fileList) {
            this.$message({
                type: 'error',
                message: "导入表单数据失败！"
            });
        },
        beforeFileUpload(file) {//验证类型
            this.loading = true;
            let type = file.type
            if (!type) {
                type = file.name.substring(file.name.lastIndexOf(".") + 1);
            }
            const isExcel = type === ('xlsx') || type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || type === 'application/sheet';                                       //限制文件格式为 word
            if (!isExcel) {
                this.$message.error('上传文件只能是xlsx文件格式');
            }
            return isExcel
        },
        fileChange(file) {
            this.actionQuery.file1 = file.raw;
            this.actionQuery.table = 'xlsFile';
        },
        handleUploadSuccess(response, file, fileList) {
            if (response.code == '1') {
                this.loading = false;
                this.pageIndex = 1;
                this.getDataList();
                this.$message({
                    type: 'success',
                    message: response.msg
                });
            } else {
                this.$message({
                    type: 'error',
                    message: response.msg
                });
            }
        },
        exportTableData() {
            if (!this.dataForm.busType) {
                this.$message({
                    type: 'error',
                    message: "请先指定业务类型！"
                });
                return
            }
            this.loading = true;
            apiCustomformExport(this.dataForm.busType).then(res => {
                this.loading = false;
                const fileNames = res.headers['content-disposition'];
                if (fileNames) {
                    //解码
                    const fileName = decodeURIComponent(fileNames.match(/=(.*)$/)[1])
                    // 处理返回的文件流
                    const content = res.data
                    const blob = new Blob([res.data], {
                        type: "application/octet-stream;charset=utf-8"
                    });
                    if ('download' in document.createElement('a')) {
                        //非IE下载
                        const a = document.createElement('a') //创建一个a标签
                        a.download = fileName //指定文件名称
                        a.style.display = 'none' //页面隐藏
                        a.href = URL.createObjectURL(blob) // href用于下载地址
                        document.body.appendChild(a) //插到页面上
                        a.click() //通过点击触发
                        URL.revokeObjectURL(a.href) //释放URL 对象
                        document.body.removeChild(a) //删掉a标签
                    } else {
                        //IE10 + 下载
                        navigator.msSaveBlob(blob, fileName)
                    }
                }

            }).catch(e => {
                console.error("请求错误：", e)
                this.loading = false;
                this.$message.error(e.msg)
            })
        },
        seachBtn() { //搜索按钮
            this.pageIndex = 1;
            this.getDataList()
        },

        ifmove() {
            let tableMaxHeight = document.documentElement.clientHeight - 285;
            // this.pageSize = parseInt((tableMaxHeight) / 50) || 1;
            this.$nextTick(() => {
                this.tableMaxHeight = tableMaxHeight
            })
            // this.getDataList()
        },
        getDic(type) { // 获取字典
            apiSysDictDataGetList(type).then(res => {
                if (res.data.code === '1') {
                    switch (type) {
                        case 'jz_dgwitness_bustype':
                            this.businessTypeNamelist = res.data.data;
                            break;
                    }
                }
            })
        },

        // 获取数据列表
        getDataList() {
            this.dataListLoading = true;
            const params = {
                page: this.pageIndex,
                rows: this.pageSize,
                searchKey: this.dataForm.searchKey,
                filter: {
                    busType: this.dataForm.busType,
                    formType: this.dataForm.formType
                },
            }
            apiCustomformList(params).then(({data}) => {
                if (data) {
                    this.dataList = data.rows;
                    this.$refs.customFormList.doLayout()
                    this.totalPage = data.totalItemCount;
                } else {
                    this.dataList = [];
                    this.totalPage = 0;
                }
                this.dataListLoading = false;
            });
        },
        getRowsIndex(index) {
            return (this.pageIndex - 1) * this.pageSize + index + 1;
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
        },
        // 新增 / 修改
        addOrUpdateHandle(id) {
            this.addOrUpdateVisible = true;
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id);
            });
        },
        configDataset(row) {
            this.selectRow = row;
            if (row.formType == 0) {
                // removeTabHandle("customform_list_config")
                // this.$router.push({
                //     name: "customform_list_config",
                //     params: {id: row.id, title: row.title},
                // });
                this.$refs.listConfigDialogRef.openVisible()
            } else if (row.formType == 1) {
                // removeTabHandle("customform_detail_config");
                // this.$router.push({
                //     name: "customform_detail_config",
                //     params: {id: row.id, busType: row.busType, title: "自定义表单配置"},
                // });
                this.$refs.detailConfigDialogRef.openVisible()
            } else {
                this.$message.error("暂时不支持编辑页面");
            }
        },
        showTest(row) {

            window.sessionStorage.setItem("busType", row.busType);
            this.$router.push({
                name: "test_list",
                params: {formId: row.id, formType: row.formType, busType: row.busType, title: "自定义表单测试",},
            });

        },
        // 删除
        deleteHandle(id) {
            let params = {}
            if (id) {
                params.id = id;
            } else {
                let ids = new Array();
                this.dataListSelections.forEach(key => {
                    ids.push(key.id)
                })
                params.idList = ids;
            }

            this.$confirm(`确定要删除该数据?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    apiCustomformDelete(params).then(({data}) => {
                        if (data && data.code === "1") {
                            this.$message({
                                message: "操作成功",
                                type: "success",
                                duration: 1500,
                                onClose: () => {
                                    this.getDataList();
                                },
                            });
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                })
                .catch(() => {
                });


        },
    },
};
</script>
